
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class SubjectInvoiceItemApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'subject-invoice-item'
  }

}

